import { React, useEffect, useState } from "react";
import { Route } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { CheckUser } from "../../Model/Users";
import Home from "../../components/home/Home"; //Include Home
import SelectTopics from "../select-topics/SelectTopics";
import ExplorePlan from "../ExplorePlan/ExplorePlan";
import Getstarted from "../Getstarted/Getstarted";
import Baypage from "../Baypage/Baypage";
import Search from "../search/Search";
import Series from "../Series/Series";
import Movies from "../Movies/Movies";
import Docubytesplayer from "../Docubytesplayer/Docubytesplayer";
import Docubytesplayertest from "../Docubytesplayertest/Docubytesplayertest";
import DocubytesSwiper from "../DocubytesSwiper/DocubytesSwiper";
import Profile from "../Profile/Profile";
import Generatepin from "../Generatepin/Generatepin";
import Manageprofile from "../Manageprofile/Manageprofile";
import Managemembership from "../Managemembership/Managemembership";
import Changeemail from "../Changeemail/Changeemail";
import Verifyemail from "../Changeemail/Verifyemail";
import Changemobile from "../Changemobile/Changemobile";
import Verifymobile from "../Changemobile/Verifymobile";
import Addemail from "../Changeemail/Addemail";
import Addmobile from "../Changemobile/Addmobile";
import AboutusMobile from "../Aboutus/AboutusMobile";
import AboutusDesktop from "../Aboutus/AboutusDesktop";
import NewsMobile from "../FooterDesk/NewsMobile";
import ContactUsMobile from "../FooterDesk/ContactUsMobile";
import TermsofuseMobile from "../Termsofus/TermsofuseMobile";
import TermsofuseDesktop from "../Termsofus/TermsofuseDesktop";
import PrivacypolicyMobile from "../Privacypolicy/PrivacypolicyMobile";
import Privacypolicy from "../Privacypolicy/Privacypolicy";
import HelpnsupportMobile from "../Helpsupport/HelpnsupportMobile";
import HelpnsupportMore from "../Helpsupport/HelpnsupportMore";
import Helpnsupport from "../Helpsupport/Helpnsupport";
import { LiveTV } from "../LiveTV/LiveTV";
import Addname from "../Addname/Addname";
import Changename from "../Addname/Changename";
import ChangePassword from "../Change-Password/PasswordChange";
import Managedevices from "../Managedevices/Managedevices";
import Watchlist from "../Watchlist/Watchlist";
import { Paymentfailed } from "../PaymentFailed/Paymentfailed";
import { Paymentsuccess } from "../Payment-success/Paymentsucess";
import Activatemembership from "../../components/Activatemembership/Activatemembership";
import News from "../../components/FooterDesk/News";
import ContactUs from "../../components/FooterDesk/ContactUs";
import DocubytesDesk from "../../components/DocubytesDesk/DocubytesDesk";
import { WatchTrailer } from "../../components/WatchTrailer/WatchTrailer";
import { Playcontent } from "../../components/Playcontent/Playcontent";
import { Playlivetv } from "../../components/Playlivetv/Playlivetv";

import { withRouter, } from "../../Helpers/Common"; //Include Home
import { Routes, } from "react-router-dom";
import { Paytmredirect } from "../PaytmRedirect/Paytmredirect";

function Privateroute() {
  const location = useLocation();
  // Add your own authentication on the below line.
  const navigate = useNavigate();
  const [Userstatus, setUserstatus] = useState(false);

  useEffect(() => {
    CheckUser().then((checkuserstatus) => {
      console.log(location.pathname.slice(0, 1), "--route name");
      if (location.pathname == "/subscription" || location.pathname == "/login") {
        navigate("/");
      }
      if (
        location.pathname == "/about-us-m" ||
        location.pathname == "/terms-m" ||
        location.pathname == "/privacy-m" ||
        location.pathname == "/help-support-m" ||
        location.pathname == "/news-m" ||
        location.pathname == "/contact-us-m" ||
        location.pathname == "/faqs" ||
        location.pathname == "/about-us" ||
        location.pathname == "/privacy" ||
        location.pathname == "/terms" ||
        location.pathname == "/news" ||
        location.pathname == "/contact-us" ||
        location.pathname.slice(0, 1) == "/" ||
        location.pathname == "/404"
      ) {
        setUserstatus(false);
      } else if (checkuserstatus == null) {
        //console.log("routing to login page")
        setUserstatus(false);
        navigate("/createaccount");
      } else {
        setUserstatus(true);
      }
    });
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route
        exact
        path="/about-us-m"
        element={<AboutusMobile mobile={true} />}
      />
      <Route
        exact
        path="/terms-m"
        element={<TermsofuseMobile mobile={true} />}
      />
      <Route
        exact
        path="/privacy-m"
        element={<PrivacypolicyMobile mobile={true} />}
      />
      <Route
        exact
        path="/help-support-m"
        element={<HelpnsupportMobile mobile={true} />}
      />
      <Route
        exact
        path="/news-m"
        element={<NewsMobile mobile={true} />}
      />
      <Route
        exact
        path="/contact-us-m"
        element={<ContactUsMobile mobile={true} />}
      />
      <Route exact path="/faqs" element={<HelpnsupportMore mobile={true} />} />
      {/* <Route exact path="/details/:content_slug" element={<Details />} /> */}
      <Route path="/getstarted/" element={<Getstarted />} />
      {/* <Route
        path="/exploreplan"
        element={<ExplorePlan title={"Get started"} skipwatch="false" />}
      /> */}
      {/* <Route
        path="/become-a-member"
        element={<BecomeMember title={"Become A Member"} skipwatch="true" />}
      /> */}
      <Route path="/select-topics" element={<SelectTopics />} />
      <Route path="/search/:docutype" element={<Search />} />
      <Route path="/movies" element={<Movies />} />
      <Route path="/series" element={<Series />} />
      <Route path="/docubyteplay" element={<Docubytesplayer />} />
      <Route path="/docubyteplaytest" element={<Docubytesplayertest />} />
      <Route path="/DocubytesSwiper" element={<DocubytesSwiper />} />

      <Route path="/profile" element={<Profile />} />
      <Route path="/generatepin" element={<Generatepin />} />
      <Route path="/manage-profile" element={<Manageprofile />} />
      <Route path="/manage-membership" element={<Managemembership />} />
      <Route path="/change-email" element={<Changeemail />} />
      <Route path="/change-mobile" element={<Changemobile />} />
      <Route path="/verify-email" element={<Verifyemail />} />
      <Route path="/verify-mobile" element={<Verifymobile />} />

      <Route path="/add-email" element={<Addemail />} />
      <Route path="/add-mobile" element={<Addmobile />} />
      <Route exact path="/baypage/:content_slug" element={<Baypage />} />
      <Route exact path="/faq" element={<Helpnsupport />} />
      <Route exact path="/privacy" element={<Privacypolicy mobile={false} />} />
      <Route
        exact
        path="/terms"
        element={<TermsofuseDesktop mobile={false} />}
      />
      <Route
        exact
        path="/about-us"
        element={<AboutusDesktop mobile={false} />}
      />
      <Route exact path="/live-tv" element={<LiveTV mobile={true} />} />
      <Route exact path="/add-name" element={<Addname mobile={true} />} />
      <Route exact path="/change-name" element={<Changename mobile={true} />} />
      <Route
        exact
        path="/change-password"
        element={<ChangePassword mobile={true} />}
      />
      <Route
        exact
        path="/manage-devices"
        element={<Managedevices mobile={true} />}
      />
      <Route exact path="/watch-list" element={<Watchlist mobile={true} />} />
      <Route exact path="/cancel-payment" element={<Paymentfailed />} />
      <Route exact path="/success-payment" element={<Paymentsuccess />} />

      {/* footer - news and contact us*/}
      <Route exact path="/news" element={<News />} />
      <Route exact path="/contact-us" element={<ContactUs />} />

      {/* activate membership */}
      <Route exact path="/activate" element={<Activatemembership />} />
      <Route exact path="/docubytes-show" element={<DocubytesDesk />} />
      <Route
        exact
        path="/watchtrailer/:content_slug"
        element={<WatchTrailer />}
      />
      <Route
        exact
        path="/playcontent/:content_slug"
        element={<Playcontent />}
      />
      <Route exact path="/playlive" element={<Playlivetv mobile={true} />} />
      <Route exact path="/paytmqrgeneration" element={<Paytmredirect />} />
      {/* <Route exact path="Not-Found" element={<NotFound />} />
      <Route path="*" element={<Navigate replace to="/Not-Found" />} /> */}
    </Routes>
  );
}
export default withRouter(Privateroute);
